/**
 * Application Entry Point
 * Sets up React Router and renders the app
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { router } from './router';
import './index.css';

// Import test auth helper in development mode
if (import.meta.env.DEV) {
  import('./utils/testAuth');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>Please refresh the page to try again.</p>
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      }
    >
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>
);
